import {createContext, getContextOrThrow} from 'src/core';
import type {CssSize} from 'shared/ui-widgets/types';

const masonryGridContextKey = Symbol('masonry-grid-ctx');

interface MasonryGridContext {
    updateGrid: () => void;
    rowGap: CssSize;
}

export function createMasonryGridContext(updateGrid: () => void, rowGap: CssSize) {
    createContext<MasonryGridContext>(masonryGridContextKey, {
        updateGrid,
        rowGap
    });
}

export function getMasonryGridContext() {
    return getContextOrThrow<MasonryGridContext>(masonryGridContextKey);
}